<template>
  
<div class="container">
      <h3 class="heading">المحقق</h3>

      <form @submit.prevent="postinfo">
        
      
 
<div class="flex">
  <div class="mb-3 input-in-con half">
      <div v-if="err">
  <div v-if="err.gender"  class="alert alert-danger" role="alert"> {{ err.gender[0]}}</div>
</div>
  <label for="exampleFormControlInput1" class="form-label">  الجنس</label>
<select class="form-select half" aria-label="Default select example" v-model="formdata.gender">
  <option disabled  selected>اختر الجنس</option>
  <option value="1">ذكر </option>
  <option value="2">انثى </option>
 
</select></div>

  <div class="mb-3 input-in-con half">
      <div v-if="err">
  <div v-if="err.name"  class="alert alert-danger" role="alert"> {{ err.name[0]}}</div>
</div>
  <label for="exampleFormControlInput1" class="form-label">اسم المحقق </label>
  <input type="text"   class="form-control half ltr" id="exampleFormControlInput1" placeholder="ادخل اسم المحقق " v-model="formdata.name">
</div>
</div>

<div class="flex">
  <div class="mb-3 input-in-con half">
      <div v-if="err">
  <div v-if="err.phone_1"  class="alert alert-danger" role="alert"> {{ err.phone_1[0]}}</div>
</div>
  <label for="exampleFormControlInput1" class="form-label">2 رقم الهاتف</label>
  <input type="text" maxlength="13" class="form-control half ltr"  id="exampleFormControlInput1" placeholder=" ادخل رقم الهاتف " v-model="formdata.phone_1">
</div>
  <div class="mb-3 input-in-con half">
      <div v-if="err">
  <div v-if="err.phone"  class="alert alert-danger" role="alert"> {{ err.phone[0]}}</div>
</div>
  <label for="exampleFormControlInput1" class="form-label">رقم الهاتف</label>
  <input type="text"  maxlength="13" class="form-control half ltr" id="exampleFormControlInput1" placeholder="ادخل رقم الهاتف " v-model="formdata.phone">
</div>
</div>

<div class="flex">
  <div class="mb-3 input-in-con half">
      <div v-if="err">
  <div v-if="err.city"  class="alert alert-danger" role="alert"> {{ err.city[0]}}</div>
</div>
  <label for="exampleFormControlInput1" class="form-label">  المدينة</label>
<select class="form-select half" aria-label="Default select example" v-model="formdata.city">
  <option disabled  selected>اختر المدينة</option>
  <option  v-for="key in formdata2" :value="key.id">{{key.name_ar}} </option>
 
</select></div>

  <div class="mb-3 input-in-con half">
      <div v-if="err">
  <div v-if="err.complanint"  class="alert alert-danger" role="alert"> {{ err.complanint[0]}}</div>
</div>
  <label for="exampleFormControlInput1" class="form-label">  القضية</label>
<select class="form-select half" aria-label="Default select example" v-model="formdata.complanint">
  <option disabled  selected>اختر القضية</option>
   <option  v-for="key in formdata3" :value="key.id">{{key.number_complaint}} </option>

</select></div>

 
</div>

<div class="flex last">
  <button  class="btn btn-primary">اضافة</button>
</div>
      </form>

  </div>

</template>

<script setup>
import { ref,onMounted } from 'vue'
import { useRouter } from 'vue-router'
import  geturl  from "@/comp/geturl";

const formdata = ref({
  name:"",
  gender:null,
  phone: "+967",
  phone_1: "+967",
  complanint: null,
  city: null
})
const formdata2 = ref(null)
const formdata3 = ref(null)
const err = ref(null)
const router = useRouter()

onMounted(()=>{

  fetch(geturl()+"complaints/complaint/", {
        
        headers: {"Content-Type": "application/json"},
        })
        .then(res => res.json())
        .then(data => {formdata3.value = data
        })

  fetch(geturl()+"city/", {
        
        headers: {"Content-Type": "application/json"},
        })
        .then(res => res.json())
        .then(data => {formdata2.value = data
        })
})

const postinfo = ()=>{

  fetch(geturl()+"records/inquisitor/", {
         method: "POST",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify(formdata.value)
      })
      .then(res => res.json())
      .then(data => { 
        if(data.error){
          err.value = data.error.details
                  }
      else{
        router.push({name:'DetictiveView' })
      }
      })

}

</script>

<style>

</style>